// Gerado por scripts/marca/desenho.py -- não edite à mão: rode o script.
// Desenho da marca AC3D (treliça + "3D"), usado por <SimboloAC3D />.

/** Enquadramento do símbolo, já com folga para a extrusão do relevo. */
export const CAIXA_DO_SIMBOLO = "142 281 1726 1273";

/** Paredes da treliça (perímetros: desenham as letras). */
export const PAREDES = "M675.3 340L191.1 1492L455.7 1492L555.8 1254M653.7 1021L789.3 698.3L968.7 1021M653.7 1021L968.7 1021M555.8 1254L1098.1 1254M675.3 340L869.3 340M869.3 340L948.9 483.3L1065.3 692.8L1297.1 1110M948.9 483.3A475 475 0 0 1 1714.8 543.5M1065.3 692.8A264 264 0 0 1 1528.7 644.2M1714.8 543.5L1528.7 644.2M1666 1382.7L1666 1114.6L1813.8 1194.2M1813.8 1194.2A522 522 0 0 1 1666 1382.7";

/** Preenchimento triangular da treliça (a textura). */
export const PREENCHIMENTO = "M653.7 1021L555.8 1254M632.3 442.4L789.3 698.3L496.6 765.1L653.7 1021L379.8 1043L555.8 1254L280.8 1278.5L455.7 1492L191.1 1492M912.9 418.4L789.3 698.3L1092.2 741.2L968.7 1021M778 459.4L675.3 340M778 459.4L869.3 340M778 459.4L632.3 442.4M778 459.4L912.9 418.4M778 459.4L789.3 698.3M653.7 1021L740.2 1254L880.5 1021M948.9 483.3L1184.5 559.8L1249.6 320.9L1372.9 535.6L1581.5 402.3L1528.7 644.2M1813.8 1194.2L1666 1254L1750.8 1297";

/** O "3D", cheio (o miolo do D é um furo: use fill-rule evenodd). */
export const LETRAS = "M925 1076L1185 1076L1265 1156L1265 1268L1231 1302L1265 1336L1265 1448L1185 1528L977 1528L925 1476L925 1372L1033 1372L1033 1420L1127 1420L1157 1390L1157 1386L1127 1356L1037 1356L1037 1248L1127 1248L1157 1218L1157 1214L1127 1184L1033 1184L1033 1232L925 1232ZM1292 1076L1518 1076L1622 1180L1622 1424L1518 1528L1292 1528ZM1400 1184L1400 1420L1484 1420L1514 1390L1514 1214L1484 1184Z";

/** Contorno de fora das letras: a treliça não invade esta área. */
export const CONTORNO_DAS_LETRAS = "M925 1076L1185 1076L1265 1156L1265 1268L1231 1302L1265 1336L1265 1448L1185 1528L977 1528L925 1476ZM1292 1076L1518 1076L1622 1180L1622 1424L1518 1528L1292 1528Z";

/** Folga entre as letras e a treliça. */
export const RESPIRO = 18;

/** Espessuras (paredes, preenchimento) de cada versão. */
export const TRACO_RELEVO = [48, 26] as const;
export const TRACO_PLANO = [56, 30] as const;

/** Deslocamento da extrusão (relevo): para baixo e para a direita. */
export const EXTRUSAO = [12, 16] as const;

/** Chanfro das letras: [trapézio, tom]. Tom de -1 (sombra) a 1 (luz). */
export const FACETAS: ReadonlyArray<readonly [string, number]> = [
  ["M925 1076L1185 1076L1176.7 1096L945 1096Z", 0.865],
  ["M1185 1076L1265 1156L1245 1164.3L1176.7 1096Z", 0.256],
  ["M1265 1156L1265 1268L1245 1259.7L1245 1164.3Z", -0.503],
  ["M1265 1268L1231 1302L1202.7 1302L1245 1259.7Z", -0.967],
  ["M1231 1302L1265 1336L1245 1344.3L1202.7 1302Z", 0.256],
  ["M1265 1336L1265 1448L1245 1439.7L1245 1344.3Z", -0.503],
  ["M1265 1448L1185 1528L1176.7 1508L1245 1439.7Z", -0.967],
  ["M1185 1528L977 1528L985.3 1508L1176.7 1508Z", -0.865],
  ["M977 1528L925 1476L945 1467.7L985.3 1508Z", -0.256],
  ["M925 1476L925 1372L945 1392L945 1467.7Z", 0.503],
  ["M925 1372L1033 1372L1013 1392L945 1392Z", 0.865],
  ["M1033 1372L1033 1420L1013 1440L1013 1392Z", -0.503],
  ["M1033 1420L1127 1420L1135.3 1440L1013 1440Z", 0.865],
  ["M1127 1420L1157 1390L1177 1398.3L1135.3 1440Z", 0.967],
  ["M1157 1390L1157 1386L1177 1377.7L1177 1398.3Z", 0.503],
  ["M1157 1386L1127 1356L1135.3 1336L1177 1377.7Z", -0.256],
  ["M1127 1356L1037 1356L1057 1336L1135.3 1336Z", -0.865],
  ["M1037 1356L1037 1248L1057 1268L1057 1336Z", 0.503],
  ["M1037 1248L1127 1248L1135.3 1268L1057 1268Z", 0.865],
  ["M1127 1248L1157 1218L1177 1226.3L1135.3 1268Z", 0.967],
  ["M1157 1218L1157 1214L1177 1205.7L1177 1226.3Z", 0.503],
  ["M1157 1214L1127 1184L1135.3 1164L1177 1205.7Z", -0.256],
  ["M1127 1184L1033 1184L1013 1164L1135.3 1164Z", -0.865],
  ["M1033 1184L1033 1232L1013 1212L1013 1164Z", -0.503],
  ["M1033 1232L925 1232L945 1212L1013 1212Z", -0.865],
  ["M925 1232L925 1076L945 1096L945 1212Z", 0.503],
  ["M1292 1076L1518 1076L1509.7 1096L1312 1096Z", 0.865],
  ["M1518 1076L1622 1180L1602 1188.3L1509.7 1096Z", 0.256],
  ["M1622 1180L1622 1424L1602 1415.7L1602 1188.3Z", -0.503],
  ["M1622 1424L1518 1528L1509.7 1508L1602 1415.7Z", -0.967],
  ["M1518 1528L1292 1528L1312 1508L1509.7 1508Z", -0.865],
  ["M1292 1528L1292 1076L1312 1096L1312 1508Z", 0.503],
  ["M1400 1184L1400 1420L1380 1440L1380 1164Z", -0.503],
  ["M1400 1420L1484 1420L1492.3 1440L1380 1440Z", 0.865],
  ["M1484 1420L1514 1390L1534 1398.3L1492.3 1440Z", 0.967],
  ["M1514 1390L1514 1214L1534 1205.7L1534 1398.3Z", 0.503],
  ["M1514 1214L1484 1184L1492.3 1164L1534 1205.7Z", -0.256],
  ["M1484 1184L1400 1184L1380 1164L1492.3 1164Z", -0.865],
];
